<template>

	<div>

		<div class="portlet box green" v-if="regularMedicines && regularMedicines.length <= 0">

			<div class="portlet-title">

				<div class="caption">
					<i class="fa fa-heartbeat" aria-hidden="true"></i>
					<span v-translate>Medicação programada</span>
				</div>

			</div>

			<div class="portlet-body tasks-widget">
				<p class="text-center m-b-0" v-translate>Não há medicação programada para o aluno(a) cadastrada pelos responsáveis.</p>
			</div>

		</div>

		<div class="portlet box green"  v-if="regularMedicines && regularMedicines.length">

			<div class="portlet-title">

				<div class="caption">
					<i class="fa fa-heartbeat" aria-hidden="true"></i>
					<span v-translate>Medicação programada</span>
				</div>

				<div class="actions"><a href="#/medicine" class="btn btn-circle btn-default"><i class="fa fa-heartbeat"></i>
				Ir para Medicações
			</a></div>

			</div>

			<div class="portlet-body tasks-widget" >

				<table class="table table-bordered table-striped table-condensed flip-content">
					<thead>
						<tr>
							<th>Status</th>
							<th>Medicação - Dosagem</th>
						</tr>
					</thead>
					<tbody>

						<tr class="font-grey-cascade" v-for="(medicine, index) in regularMedicines">
							<td v-if="medicine.isTaken == 1"><i class="fa fa-check font-green" aria-hidden="true"></i>  Ministrada</td>
							<td v-if="medicine.isTaken == 0 && getTimeDiff(medicine.time) > 0"><i class="fa fa-exclamation-triangle font-red" aria-hidden="true"></i>  Atrasada - {{medicine.time | date('HH:mm', true) }}</td>
							<td v-if="medicine.isTaken == 0 && getTimeDiff(medicine.time) <= 0"><i class="fa fa-calendar-minus-o" aria-hidden="true"></i>  Programada para {{medicine.time | date('HH:mm', true) }}</td>
							<td>{{medicine.medicine}} - {{medicine.dosage}}</td>
						</tr>

					</tbody>
				</table>

			</li>
		</ul>

	</div>

</div>

</div>

</div>

</template>

<script>

import ScheduledMedicine from './';
export default ScheduledMedicine;

</script>



// WEBPACK FOOTER //
// scheduled-medicine.vue?319dc940